import { render } from "./MultipleSelect.vue?vue&type=template&id=656b53a2&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=656b53a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656b53a2"]])

export default __exports__